import React from "react";

/**
 * @component ReportsIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ReportsIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ReportsIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ReportsIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M17 6v2H7V6H6v15h12V6h-1zm0-2h1a2 2 0 012 2v15a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h1V3h2c.336-2 1.336-3 3-3s2.664 1 3 3h2v1zM8 16h2v3H8v-3zm3-3h2v6h-2v-6zm3-3h2v9h-2v-9zm-1-5V3.332C13 2.327 12.61 2 12 2s-1 .303-1 1.332V5H9v1h6V5h-2z" />
      <path
        stroke="#F4F5F7"
        strokeWidth={0.1}
        opacity={0.01}
        d="M.05.05h23.9v23.9H.05z"
      />
    </svg>
  )
);
ReportsIcon.displayName = "ReportsIcon";
export default ReportsIcon;
